
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexoBp6IoYDxx_45poNXwSKyOmYcPMnHDN2vY406tDkRosjIMeta } from "/home/user/www/admin.qcontrol.su/pages/index.vue?macro=true";
import { default as _91id_93h3JblYspKa6uwk7yf9p6y7wqy4rwQFbMfrWjDHBUMFoMeta } from "/home/user/www/admin.qcontrol.su/pages/wiki/[id].vue?macro=true";
import { default as login8v89rb8R5TRyNeNDhhApw9KdueKM8CSEQUxm_45EKD2ToMeta } from "/home/user/www/admin.qcontrol.su/pages/auth/login.vue?macro=true";
import { default as indexWkNMeDc_45cQ6s0JdIhHD3CuFrQtZWhAXJZl5gy157K8wMeta } from "/home/user/www/admin.qcontrol.su/pages/wiki/index.vue?macro=true";
import { default as _91id_93SSl8wu5F18ylqK6fDXCU_45OSNfdADD4Y2gK9bITEg6fIMeta } from "/home/user/www/admin.qcontrol.su/pages/objects/[id].vue?macro=true";
import { default as _91id_93Tjb1q5zg8ccPakxMd78OMTCUMarN6vrLsql3c7dHUcgMeta } from "/home/user/www/admin.qcontrol.su/pages/reports/[id].vue?macro=true";
import { default as index1cGKqS1u_J61hGd07wCwLoozphmgf6ZPMsJLOuikLxMMeta } from "/home/user/www/admin.qcontrol.su/pages/objects/index.vue?macro=true";
import { default as indexWQ8ICIVgXRAOl1XzbQ9rh_45AG9f_45n2ZL74yFcs3tomLMMeta } from "/home/user/www/admin.qcontrol.su/pages/profile/index.vue?macro=true";
import { default as _91id_93p9AfQqcDBGiEPxnCJ6A4AN_epkxLNahpHNA37xdg6AQMeta } from "/home/user/www/admin.qcontrol.su/pages/projects/[id].vue?macro=true";
import { default as _91id_93FJ2dCfZXXXksRg5_w8lITBnmnbaKgII4JAA5olhJPkIMeta } from "/home/user/www/admin.qcontrol.su/pages/settings/[id].vue?macro=true";
import { default as two_45stepsyQbAK7b439Pyg0N3khJCW6PaVH6kbB52BiG_458ByP42QMeta } from "/home/user/www/admin.qcontrol.su/pages/auth/two-steps.vue?macro=true";
import { default as _91id_93yT_45ODAv_45OPTpOUx7ZKOWYzjnn_H8FboZb8DkVByykQIMeta } from "/home/user/www/admin.qcontrol.su/pages/employees/[id].vue?macro=true";
import { default as indexTyN1mvgLa7Ot1BFe1Mfv80t4xrGUW8JdLTxcsE4AV4sMeta } from "/home/user/www/admin.qcontrol.su/pages/projects/index.vue?macro=true";
import { default as index8ji2KVWF93Bb2WVuWX1rCuPI_8_45Pr3MowS4TPMViQUkMeta } from "/home/user/www/admin.qcontrol.su/pages/settings/index.vue?macro=true";
import { default as _91id_93ztefneSW7ooK7r17YBYW_45p_ud02py7Xeg7FG2ae21gcMeta } from "/home/user/www/admin.qcontrol.su/pages/checklists/[id].vue?macro=true";
import { default as indexTChokoVPeJhvrn5IgTAne_45UMoRZyrVtjgASJc9SI0gQMeta } from "/home/user/www/admin.qcontrol.su/pages/employees/index.vue?macro=true";
import { default as _91id_93xVjzM8aHSzr4Kd6sNJfS5wT7DbZ5iCCyJufH1FqeLz4Meta } from "/home/user/www/admin.qcontrol.su/pages/responsibles/[id].vue?macro=true";
import { default as _91id_932lFAwKoBzhSVxtPniZUR2YjHXqiONirS7HZ4X0smWlIMeta } from "/home/user/www/admin.qcontrol.su/pages/prescriptions/[id].vue?macro=true";
import { default as indexvkmtf8f9C8sWDqHttvtiW5180j9tsoXeyohTSWaz__45wMeta } from "/home/user/www/admin.qcontrol.su/pages/responsibles/index.vue?macro=true";
import { default as _91id_93_ZITZnCLhUrizhlpQB1kOX_45Choh6iqGWHuh0idpwCXcMeta } from "/home/user/www/admin.qcontrol.su/pages/wiki/articles/[id].vue?macro=true";
import { default as reset_45passwordQXLfz_450nxmGZzfDDzuB4KgfQwMEn_UrbkL_45zJLEBsywMeta } from "/home/user/www/admin.qcontrol.su/pages/auth/reset-password.vue?macro=true";
import { default as forgot_45passwordrh2JWMb1HfN2AWwP7_4507PJu4oR9VZlWapCvQd4gxvNYMeta } from "/home/user/www/admin.qcontrol.su/pages/auth/forgot-password.vue?macro=true";
import { default as _91id_93TnYzrmsr35mLN0xAEYdlMvyPdcFGuirAJaDIJX1iAqQMeta } from "/home/user/www/admin.qcontrol.su/pages/objects/documents/[id].vue?macro=true";
import { default as _91id_93joBZafA6OiJk6r_45ViI29Wwje1Ti_45AC1aiDea1l0_45Um8Meta } from "/home/user/www/admin.qcontrol.su/pages/projects/documents/[id].vue?macro=true";
import { default as _91id_93Zj_A4RX_MP7idrBOc6e6f_82O4LS8Xlyp7Vd8gl_lA8Meta } from "/home/user/www/admin.qcontrol.su/pages/objects/documents-preview/[id].vue?macro=true";
import { default as _91id_93P_g7_sFjJv9IJQiuGYMWO0gvilRQ0evLpNrbl3gJnmAMeta } from "/home/user/www/admin.qcontrol.su/pages/projects/documents-preview/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/index.vue")
  },
  {
    name: "wiki-id",
    path: "/wiki/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/wiki/[id].vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: login8v89rb8R5TRyNeNDhhApw9KdueKM8CSEQUxm_45EKD2ToMeta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/auth/login.vue")
  },
  {
    name: "wiki",
    path: "/wiki",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/wiki/index.vue")
  },
  {
    name: "objects-id",
    path: "/objects/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/objects/[id].vue")
  },
  {
    name: "reports-id",
    path: "/reports/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/reports/[id].vue")
  },
  {
    name: "objects",
    path: "/objects",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/objects/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/profile/index.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/projects/[id].vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/settings/[id].vue")
  },
  {
    name: "auth-two-steps",
    path: "/auth/two-steps",
    meta: two_45stepsyQbAK7b439Pyg0N3khJCW6PaVH6kbB52BiG_458ByP42QMeta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/auth/two-steps.vue")
  },
  {
    name: "employees-id",
    path: "/employees/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/employees/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/projects/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/settings/index.vue")
  },
  {
    name: "checklists-id",
    path: "/checklists/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/checklists/[id].vue")
  },
  {
    name: "employees",
    path: "/employees",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/employees/index.vue")
  },
  {
    name: "responsibles-id",
    path: "/responsibles/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/responsibles/[id].vue")
  },
  {
    name: "prescriptions-id",
    path: "/prescriptions/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/prescriptions/[id].vue")
  },
  {
    name: "responsibles",
    path: "/responsibles",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/responsibles/index.vue")
  },
  {
    name: "wiki-articles-id",
    path: "/wiki/articles/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/wiki/articles/[id].vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45passwordQXLfz_450nxmGZzfDDzuB4KgfQwMEn_UrbkL_45zJLEBsywMeta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/auth/reset-password.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordrh2JWMb1HfN2AWwP7_4507PJu4oR9VZlWapCvQd4gxvNYMeta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/auth/forgot-password.vue")
  },
  {
    name: "objects-documents-id",
    path: "/objects/documents/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/objects/documents/[id].vue")
  },
  {
    name: "projects-documents-id",
    path: "/projects/documents/:id()",
    component: () => import("/home/user/www/admin.qcontrol.su/pages/projects/documents/[id].vue")
  },
  {
    name: "objects-documents-preview-id",
    path: "/objects/documents-preview/:id()",
    meta: _91id_93Zj_A4RX_MP7idrBOc6e6f_82O4LS8Xlyp7Vd8gl_lA8Meta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/objects/documents-preview/[id].vue")
  },
  {
    name: "projects-documents-preview-id",
    path: "/projects/documents-preview/:id()",
    meta: _91id_93P_g7_sFjJv9IJQiuGYMWO0gvilRQ0evLpNrbl3gJnmAMeta || {},
    component: () => import("/home/user/www/admin.qcontrol.su/pages/projects/documents-preview/[id].vue")
  }
]